import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { Tv3PlatformModule } from '@tokeet-frontend/tv3-platform'
import { ConnectHopperWizardComponent } from './connect-hopper-wizard.component'
import { ConnectHopperWizardCompleteComponent } from './complete/connect-hopper-wizard-complete.component'
import { ConnectHopperWizardStep1Component } from './step1/connect-hopper-wizard-step1.component'
import { ConnectHopperWizardStep2Component } from './step2/connect-hopper-wizard-step2.component'

import { SharedModule } from '@tv3/shared/shared.module'

const components = [
  // Hopper
  ConnectHopperWizardStep1Component,
  ConnectHopperWizardStep2Component,
  ConnectHopperWizardCompleteComponent,
  ConnectHopperWizardComponent,
]

const services = []

const pipes = []

@NgModule({
  declarations: [...components, ...pipes],
  exports: [...components],
  providers: [...services],
  imports: [CommonModule, SharedModule, Tv3PlatformModule],
})
export class ConnectHopperWizardModule {}
